import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { RiCloseLine } from "react-icons/ri";
import { FaFacebookF } from "react-icons/fa";
import { RiTwitterLine, RiLinkedinLine } from "react-icons/ri";
import NavbarContext from "../context/navbar/NavbarContext";
import logo from "../assets/images/logo.svg";

// Menu Items as array
const menuItems = [
  {
    id: 1,
    name: "Home",
    label: "home",
    path: "/",
  },
  {
    id: 2,
    name: "Our Works",
    label: "our-works",
    path: "/our-works",
  },
  {
    id: 3,
    name: "About Us",
    label: "about-us",
    path: "/about-us",
  },
  {
    id: 4,
    name: "Contact Us",
    label: "contact-us",
    path: "/contact-us",
  },
];

function MobileMenu() {
  const { closeMenu } = useContext(NavbarContext);

  return (
    <>
      <nav className="md:hidden fixed z-50 h-screen bg-bg-black w-full overflow-x-hidden">
        <div className="py-4 md:py-8 px-4 md:px-0 bg-bg-white">
          <div className="flex items-center justify-between  w-full">
            <div className="logo">
              <Link to="/">
                <img src={logo} alt="Protis" className="h-[44px] w-[150px]" />
              </Link>
            </div>
            <div
              className="bg-white h-[28px] w-[28px] border border-black rounded-[8px] flex items-center justify-center md:hidden cursor-pointer"
              onClick={closeMenu}
            >
              {" "}
              <RiCloseLine size={20} />
            </div>
          </div>
        </div>
        <ul className="md:hidden z-50 p-0 mb-12 text-center flex flex-col items-center justify-center mx-auto w-full translate-y-6 ease-in duration-300 ">
          {menuItems.map((item) => (
            <li className="my-8" key={item.id} onClick={() => {closeMenu()}}>
              <Link
                to={item.path}
                className="no-underline menu-links px-5 text-white/70 text-lg font-sfpro font-medium hover:text-white hover:scale-100"
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
        <div className="px-[16px] mt-[224px] pb-[51px]">
          <div className="flex flex-col md:flex-row md:items-center items-start justify-between">
            <div>
              <h3 className="text-[22px] font-sfpro text-white opacity-50">
                Reach us via socials
              </h3>
              <div className="mt-5 flex items-center">
                <Link className="bg-transparent border border-white rounded-[50%] flex items-center justify-center h-[56px] w-[56px] mx-3">
                  <FaFacebookF size={20} color="#ffffff" />
                </Link>
                <Link className="bg-transparent border border-white rounded-[50%] flex items-center justify-center h-[56px] w-[56px] mx-3">
                  <RiTwitterLine size={23} color="#ffffff" />
                </Link>
                <Link className="bg-transparent border border-white rounded-[50%] flex items-center justify-center h-[56px] w-[56px] mx-3">
                  <RiLinkedinLine size={23} color="#ffffff" />
                </Link>
              </div>
            </div>

            <div className="flex items-start justify-start flex-col md:mt-0 mt-8">
              <h3 className="text-base text-white opacity-70 font-sfpro">
                Copyright © Protis Studios{" "}
              </h3>
              <ul className="items-center flex">
                <li
                  className={`mr-2 py-3 cursor-pointer font-normal text-white`}
                >
                  <Link
                    to="/privacy-policy"
                    className="text-base font-sfpro font-normal"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li
                  className={`mx-3 py-3 cursor-pointer font-normal text-white`}
                >
                  <Link
                    to="/our-works"
                    className="text-base font-sfpro font-normal"
                  >
                    CAC Approved
                  </Link>
                </li>
                <li
                  className={` mx-3 py-3 cursor-pointer font-normal text-white`}
                >
                  <Link
                    to="/legal"
                    className="text-base font-sfpro font-normal"
                  >
                    Legal
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default MobileMenu;
